import { render } from "./SocialLink.vue?vue&type=template&id=29360c65&scoped=true&ts=true"
import script from "./SocialLink.vue?vue&type=script&lang=ts"
export * from "./SocialLink.vue?vue&type=script&lang=ts"

import "./SocialLink.vue?vue&type=style&index=0&id=29360c65&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/atomic-design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29360c65"]])

export default __exports__